import { useCreateEnrichmentContext } from '@aibees/elephant/feature/new-enrichment-dialog/context';
import { ROUTES } from '@aibees/elephant/router';
import { SearchType } from '@aibees/elephant/types';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import { useMatchRoute } from '@aibees/shared/hooks';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from '../use-page-type';

export function useLabelTypeFromRoute() {
  const { enrichmentType } = useCreateEnrichmentContext();
  const { isCompanyPage } = usePageType();
  const type = useSearchTypeFromRoute();
  const isCompanyEmployees = useMatchRoute(ROUTES.companyEmployees);

  const isCompany = isCompanyPage || type === SearchType.Company;

  let labelGroup: LabelGrouping = isCompany
    ? LabelGrouping.COMPANY
    : LabelGrouping.PEOPLE;

  if (enrichmentType) {
    labelGroup =
      enrichmentType === EnrichmentTypeEnum.PERSON
        ? LabelGrouping.PEOPLE
        : LabelGrouping.COMPANY;
  }

  if (isCompanyEmployees) {
    labelGroup = LabelGrouping.PEOPLE;
  }

  return labelGroup;
}
